import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import PatientFormField from '../PatientFormField'
import { FormatedPatientFormData } from '../_props'
import { cleanAccentsAndDiacritics } from '../../../../utils/stringUtils'

const FieldName: keyof FormatedPatientFormData = 'firstFirstName'

const FirstFirstName = () => {
    const { control, watch } = useFormContext<FormatedPatientFormData>()

    const firstNameList = watch('firstNameList')

    const isDisabled = !firstNameList || firstNameList.length < 2

    const firstNameListOptions = useMemo(() => {
        if (!firstNameList) return []
        return firstNameList.reduce<{ value: string; label: string }[]>((acc, item) => {
            if (item?.__typename === 'Element') {
                const { value } = item
                acc.push({
                    value: cleanAccentsAndDiacritics(value).toUpperCase(),
                    label: cleanAccentsAndDiacritics(value).toUpperCase(),
                })
            } else if (typeof item === 'string') {
                acc.push({
                    value: cleanAccentsAndDiacritics(String(item)).toUpperCase(),
                    label: cleanAccentsAndDiacritics(String(item)).toUpperCase(),
                })
            }
            return acc
        }, [])
    }, [firstNameList])

    return (
        <Controller
            control={control}
            name={FieldName}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="select"
                    type="default"
                    label="1er prénom de naissance"
                    name={field.name}
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    required
                    value={cleanAccentsAndDiacritics(String(field?.value?.toUpperCase() ?? ''))}
                    dataCyScope="PatientField"
                    placeholder="Premier prénom de naissance"
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    options={firstNameListOptions}
                    disabled={isDisabled}
                />
            )}
        />
    )
}

export default FirstFirstName
